import { isEmpty } from 'lodash';

import { Operator } from '@app/components';

export const getFacetsCQL = (facets: Record<string, string[]> | undefined) =>
  facets && !isEmpty(facets)
    ? Object.keys(facets)
        .filter(facetKey => !isEmpty(facets[facetKey]))
        .map(
          facetKey =>
            `${facetKey}${Operator.phraseMatch}(${facets[facetKey]
              .map(facetValue =>
                '"'.concat(facetValue.replace(/"/g, '\\"')).concat('"')
              )
              .join(' or ')})`
        )
        .join(' AND ')
    : '';
